import router from '@/router';

export default {
  state:
  {
    searchVal: '',
    detailData: {},
    faceCouponList: [],
    faceCouponLoading: false,
    faceCouponCancelPage: {
      total: 0,
      pageNum: 1,
      pageSize: 2,
    }, /**数量，页码信息 */
    faceMoreList: [],
  },
  getters:
  {

  },
  mutations:
  {
    getDetailData(state: any, data: any) {
      state.detailData = data
    },
    setFaceCouponLoading(state: any, status: boolean) {
      if (status) {
        state.faceCouponLoading = true;
      } else {
        state.faceCouponLoading = false;
      }
    },
    setFaceCouponList(state: any, { list, total, pageNum, pageSize }: any) {
      const _list = list.map((item: any) => {
        let _item = item;
        _item.couponEffectiveStartTime = router.app.$format(_item.couponEffectiveStartTime, "YYYY.MM.DD");
        _item.couponEffectiveEndTime = router.app.$format(_item.couponEffectiveEndTime, "YYYY.MM.DD");
        return _item
      });
      state.faceCouponList = [...state.faceCouponList, ..._list];
      state.faceCouponCancelPage = {
        total,
        pageNum,
        pageSize,
      }; /**数量，页码信息 */
    },
    getFaceMoreList(state: any, getMoreList: any) {
      console.log('getMoreList', getMoreList);
      const _list = getMoreList.map((item: any) => {
        let _item = item;
        _item.couponGetStartTime = router.app.$format(_item.couponGetStartTime, "YYYY.MM.DD");
        _item.couponGetEndTime = router.app.$format(_item.couponGetEndTime, "YYYY.MM.DD");
        return _item
      });
      state.faceMoreList = [..._list]
    }
  },
  actions:
  {
    async getMemberDetailByQrCode({ commit, state }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
        params.searchType = 3
        const { error, success }: any = await router.app.$request('FACECOUPON_MEMBER_SEARCH', params);
        if (success) {
          router.app.$router.push({
            path: "/faceCoupon/couponSure",
            query: { val: params.searchText, type: params.searchType }
          });
        }
        if (error) {
          params.searchType = 3
          const { error, success }: any = await router.app.$request('SEARCH_MEMBER_QRCODE', params);
          if (success) {
            router.app.$router.push({
              path: "/faceCoupon/couponSure",
              query: { val: params.searchText, type: params.searchType }
            });
          }
          error && router.app.$dialog({ message: error.msg });
        }
      return { error, success };
    },
    async getMemberDetail({ commit, state }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
      params.searchType = 1
      const { error, success }: any = await router.app.$request('FACECOUPON_MEMBER_SEARCH', params);
      if (success) {
        router.app.$router.push({
          path: "/faceCoupon/couponSure",
          query: { val: params.searchText, type: params.searchType }
        });
      }
      if (error) {
        params.searchType = 3
        const { error, success }: any = await router.app.$request('FACECOUPON_MEMBER_SEARCH', params);
        if (success) {
          router.app.$router.push({
            path: "/faceCoupon/couponSure",
            query: { val: params.searchText, type: params.searchType }
          });
        }
        error && router.app.$dialog({ message: error.msg });
      }
      return { error, success };
    },
    async getMemberDetailData({ commit, state }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
      const { error, success }: any = await router.app.$request('FACECOUPON_MEMBER_SEARCH', params);
      if (success) {
        commit('getDetailData', success.data);
      }
      return { error, success };
    },
    async getFaceCouponList({ commit }: any, params: any) {
      commit('setFaceCouponLoading', true);
      const { error, success }: any = await router.app.$request('FACECOUPON_LIST', params);
      if (success) {
        // commit('setFaceCouponList', success.data);
        commit('setFaceCouponLoading', false);
      }
      return { error, success };
    },
    async faceCouponGetMore({ commit, state }: any, params: any) {
      const { error, success }: any = await router.app.$request('FACECOUPON_GET_MORE', params);
      console.log('success', success);
      if (success) {
        // commit('getFaceMoreList', success.data.getMoreList);
        if (success.data && success.data.getMoreList) {
          success.data.getMoreList.map((item: any) => {
            item.couponGetStartTime = router.app.$format(item.couponGetStartTime, "YYYY.MM.DD");
            item.couponGetEndTime = router.app.$format(item.couponGetEndTime, "YYYY.MM.DD")
          })
        }
        if (success.data && success.data.notGetMoreList) {
          success.data.notGetMoreList.map((item: any) => {
            item.couponGetStartTime = router.app.$format(item.couponGetStartTime, "YYYY.MM.DD");
            item.couponGetEndTime = router.app.$format(item.couponGetEndTime, "YYYY.MM.DD")
          })
        }
        sessionStorage.setItem('faceCouponGetMoreList', JSON.stringify(success.data))
        router.app.$router.push({
          path: "/faceCoupon/CouponSuccess"
        });
      }
      error && router.app.$dialog({ message: error.msg });
      return { error, success };
    },
  },
};
